export default __webpack_public_path__ + "static/media/estanciapopayan.63c86e23.jpg";